export const contactInfo = {
  heading: "Contact us",
  subHeading: "Let's get in touch.",
  description: "For more information, feel free to WhatsApp us",
  phoneLabel: "Phone",
  phoneNumber: "+6012-3063136",
  locationLabel: "Location",
  addressLines: [
    "No 44B, Jalan BRP 6/11,",
    "Bukit Rahman Putra,",
    "Sungai Buloh, Selangor."
  ]
};


